import { apiFetch } from "./apiFetch";

export const getTickets = async (limit = 20, before = null, beforeStamp = null) => {
  try {
    let url = `/tickets?limit=${limit}`;

    if (before) {
      url += `&before=${encodeURIComponent(before)}`;
    }

    if (beforeStamp) {
      url += `&beforeStamp=${encodeURIComponent(beforeStamp)}`;
    }

    const response = await apiFetch(url);

    if (!response.ok) {
      throw new Error(`Erro ao buscar tickets: ${response.status}`);
    }

    const data = await response.json();

    return {
      tickets: data.tickets || [],
      hasMore: data.hasMore || false
    };

  } catch (err) {
    return {
      tickets: [],
      hasMore: false,
      error: err.message
    };
  }
};

export const getTicketMensagens = async (ticketStamp) => {
  try {
    const response = await apiFetch(
      `/tickets/${encodeURIComponent(ticketStamp)}/mensagens`
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar mensagens do ticket: ${response.status}`
      );
    }

    const data = await response.json();

    return {
      ticketStamp: data.ticketStamp,
      total: data.total || 0,
      mensagens: data.mensagens || []
    };

  } catch (err) {
    return {
      ticketStamp,
      total: 0,
      mensagens: [],
      error: err.message
    };
  }
};

export const updateTicket = async (ticketId, payload) => {


  const response = await apiFetch(`/tickets/${encodeURIComponent(ticketId)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Erro ao atualizar ticket: ${response.status}`);
  }

  return response.status === 204 ? null : response.json();
};

export const updateTicketStatus = async (stamp, estado) => {
  const response = await apiFetch(
    `/tickets/${encodeURIComponent(stamp)}/estado`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ESTADO: estado }),
    }
  );

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || `Erro HTTP: ${response.status}`);
  }

  return response.status === 204 ? null : response.json();
};